<template>
  <validation-observer ref="amendmentContractFormRef" tag="form">
    <custom-callout border-color="orange" :has-toggle="false">
      <div class="ml-n0 ml-md-n3 mr-3">
        <icon-view
          icon="mb-1 ml-1 fa fa-file-signature"
          icon-background="#fff"
          icon-color="#FF7058"
          icon-size="14px"
          title="Enmendar Contrato"
        />
        <div v-if="!isReadOnly" class="mt-3">
          <span class="color-gray-6 d-block font-14 mb-1">Tipo de Razón:</span>
          <div class="row">
            <div class="col-5 col-sm col-12">
              <validation-provider
                v-slot="{ errors }"
                :rules="selectedReasons.length > 0 ? '' : 'required|min:1'"
              >
                <custom-drop-down
                  id="reasonType"
                  v-model="model.reasonType"
                  custom-error-msg="Debe añadir al menos 1 Tipo de Razón."
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  :options="availableReasonTypes"
                  placeholder="Seleccione"
                />
              </validation-provider>
            </div>
            <div class="col-7 col-sm col-12 mt-3 mt-md-0">
              <action-button
                id="btnAdd"
                i="fas fa-file-plus fa-lg"
                text="Añadir"
                variant="success"
                @click="onAddHandler"
              />
            </div>
          </div>
        </div>
        <div v-if="selectedReasons?.length" class="mt-3">
          <span class="color-gray-6 d-block font-14 mb-1">
            Razón(es) de Enmienda Seleccionada(s):
          </span>
          <div>
            <div
              v-for="(item, index) in selectedReasons"
              :key="`reason-item-${index}`"
            >
              <div
                class="reason-item d-flex align-items-center mr-2 my-2"
                :class="{ 'bg-white': isReadOnly }"
              >
                <div class="d-flex flex-row flex-grow-1 align-items-center">
                  <div
                    v-if="item.selectedSubReason && isReadOnly"
                    style="width: 47px; height: 30px; margin-right: -10px; cursor: pointer; margin-left: -5px;"
                    @click="toggleSubReason(item)"
                  >
                    <icon-view
                      :icon="
                        item.showSubReason
                          ? 'fa fa-minus font-12'
                          : 'fa fa-plus font-12'
                      "
                      :icon-background="
                        item.showSubReason ? '#FF7058' : '#3F5B60'
                      "
                      icon-color="#fff"
                      icon-size="14px"
                    />
                  </div>
                  <span
                    class="color-black font-16 font-weight-bold flex-grow-1"
                  >
                    {{ item.name }}
                  </span>
                </div>
                <i
                  v-if="!isReadOnly"
                  class="far fa-times-circle text-red font-16 cursor-pointer ml-2 mt-1"
                  @click="onDeleteItemHandler(index)"
                />
              </div>
              <transition name="slide-fade">
                <div
                  v-if="
                    item.subReasons?.length ||
                      (isReadOnly && item.showSubReason)
                  "
                  class="reason-item__sub-type"
                >
                  <div class="row">
                    <div class="col-6">
                      <span class="color-gray-6 d-block font-14 mb-1">
                        Sub Razón:
                      </span>
                      <validation-provider v-slot="{ errors }" rules="required">
                        <custom-drop-down
                          id="reasonSubType"
                          v-model="item.selectedSubReason"
                          class="custom-drop-down__extended"
                          custom-error-msg="La sub razón es requerida."
                          :disabled="isReadOnly"
                          :error="errors[0]"
                          fieldkey="id"
                          fieldname="name"
                          :options="item.subReasons"
                          placeholder="Seleccione"
                          @input="
                            () => {
                              item.subReasonOtherName = undefined;
                            }
                          "
                        />
                      </validation-provider>
                    </div>
                    <div
                      v-if="canAddAmendmentReasonDocument(item)"
                      class="col-6 justify-content-end align-items-center"
                    >
                      <div
                        class="col-12 col-md justify-content-end align-items-center"
                      >
                        <span
                          v-if="!isReadOnly || (isReadOnly && item.documentId)"
                          class="color-gray-6 d-block font-14 mb-1 ml-3"
                        >
                          Archivo:
                        </span>
                        <custom-file-input
                          ref="amendmentReasonDocumentInputRef"
                          v-model="item.file"
                          accept=".pdf"
                          accept-terms-modal-title="Certificación"
                          accept-terms-text="Certifico que este documento que he subido al Sistema REMpro es copia fiel y exacta del original que pertenece a los récords de la Unidad Secretarial del Procedimiento de Querellas y Remedio Provisional (USPQRP) y que como proveedor de servicios seré custodio del mismo. Reconozco y acepto que este documento original me puede ser solicitado por la USPQRP en cualquier momento.(0423)"
                          accept-terms-title="Acepto los términos y responsabilidades"
                          accept-terms-validation-msg="Favor certifique el documento  que ha subido al sistema REMpro."
                          allow-accept-terms
                          class="file-amendment-reason-input__extended"
                          :disabled="isReadOnly"
                          display-style="normal"
                          label-position="right"
                          :on-download="() => handleDownloadFile(item)"
                          @input="(file) => handleChangeFile(file, item)"
                        />
                        <div
                          v-if="item.documentId"
                          class="d-flex align-items-center ml-3"
                        >
                          <div class="mr-3">
                            {{ item.documentFileName | empty }}
                          </div>
                          <action-button
                            class="mr-2 border-green document-button-icon success"
                            i="fas fa-file-download mr-n1 pr-1"
                            @click="handleDownloadFile(item)"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="hasSubReasonOtherSelected(item)"
                      class="col-6"
                      :class="{ 'mt-3': canAddAmendmentReasonDocument(item) }"
                    >
                      <span class="color-gray-6 d-block font-14 mb-1">
                        Especifique:
                      </span>
                      <validation-provider v-slot="{ errors }" rules="required">
                        <custom-input
                          v-model="item.subReasonOtherName"
                          class="custom-input__extended"
                          custom-error-msg="Favor especificar la sub razón."
                          :disabled="isReadOnly"
                          :error="errors[0]"
                        />
                      </validation-provider>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
          <validation-provider
            v-slot="{ errors }"
            :rules="{ required: hasReasonsSelected }"
          >
            <custom-error
              v-if="errors[0]"
              class="mt-2"
              message="La razón es requerida."
              variant="no-border"
            />
          </validation-provider>
        </div>
        <div class="mt-3">
          <span class="color-gray-6 d-block font-14 mb-1">
            Comentario:
          </span>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-text-area
              id="comment"
              v-model="model.comment"
              :count-classes="['float-right']"
              custom-error-msg="El comentario es requerido."
              :disabled="isReadOnly"
              :error="errors[0]"
              :maxlength="3000"
              show-char-count
            />
          </validation-provider>
        </div>
        <div
          v-if="!isReadOnly"
          class="mt-5 mb-3 align-items-center d-flex justify-content-end"
        >
          <action-button
            id="btnCancel"
            i="fas fa-times-circle"
            text="Cancelar"
            variant="outline-danger mr-3 pl-3 pr-4"
            @click="$emit('on-cancel')"
          />
          <action-button
            id="btnContinue"
            i="fas fa-arrow-alt-circle-right"
            text="Continuar"
            variant="success pl-3 pr-3"
            @click="onContinueHandler"
          />
        </div>
      </div>
    </custom-callout>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';

//libs
import CustomCallout from 'custom-callout';
import IconView from 'icon-view';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import CustomTextArea from 'CustomTextArea';
import CustomError from 'custom-error';
import CustomInput from 'CustomInput';
import CustomFileInput from 'CustomFileInput';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import rpAmendmentSubReasonTypes from '@/utils/constants/rpAmendmentSubReasonTypes';
import rpContractAmendmentReasons from '@/utils/constants/rpContractAmendmentReasons';

// services
import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api.js';

export default {
  name: 'ContractAmendment',
  mixins: [alertMixin],
  components: {
    ValidationObserver,
    ValidationProvider,
    CustomCallout,
    IconView,
    CustomDropDown,
    ActionButton,
    CustomTextArea,
    CustomError,
    CustomInput,
    CustomFileInput,
  },
  props: {
    reasonTypes: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    model: {
      reasonType: null,
      comment: null,
      amendmentReasonFile: null,
    },
    selectedReasons: [],
  }),
  computed: {
    availableReasonTypes() {
      return this.reasonTypes.filter(
        (x) => !this.addedReasonTypeIds.includes(x.id)
      );
    },
    addedReasonTypeIds() {
      return this.selectedReasons.map((x) => x.id);
    },
    hasReasonsSelected() {
      return !this.selectedReasons?.length;
    },
    hasSubReasonOtherSelected() {
      return (item) => {
        return item.selectedSubReason?.id === rpAmendmentSubReasonTypes.OTRO;
      };
    },
    canAddAmendmentReasonDocument() {
      return (item) => {
        return item.id === rpContractAmendmentReasons.ModifyOrAddContractor;
      };
    },
  },
  methods: {
    onAddHandler() {
      const reasonType = {
        ...this.model.reasonType,
        selectedSubReason: undefined,
      };
      if (!reasonType?.id) {
        this.ShowToast(
          'Alerta',
          'Favor seleccionar al menos una razón.',
          'error'
        );
        return;
      }

      this.selectedReasons.push(reasonType);
      this.model.reasonType = null;
    },
    onDeleteItemHandler(index) {
      this.selectedReasons.splice(index, 1);
    },
    async onContinueHandler() {
      const isFormValid = await this.$refs.amendmentContractFormRef.validate();

      if (!isFormValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      } else {
        if (this.selectedReasons.length == 0) {
          this.ShowToast(
            'Alerta',
            'Para continuar, por favor presione el botón Añadir razón.',
            'error'
          );
          return;
        }
      }

      const payload = {
        amendmentReasons: this.selectedReasons.map((item) => ({
          reasonId: item.id,
          subReasonId: item.selectedSubReason?.id,
          reasonOtherName: item.subReasonOtherName,
          file: item.file,
        })),
        comment: this.model.comment,
      };

      this.$emit('on-continue', payload);
    },
    toggleSubReason(item) {
      this.$set(item, 'showSubReason', !item.showSubReason);
    },
    handleDownloadFile({ documentId }) {
      if (documentId) {
        _downloadDocumentByAttachmentId(documentId).catch((err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          );
        });
      }
    },
    async handleChangeFile(file, item) {
      if (file && item.reasonDocumentId) {
        item.reasonDocumentId = null;
        this.$refs.amendmentReasonDocumentInputRef[0].removeFile();
      }
    },
  },
  watch: {
    data: {
      handler() {
        this.model.comment = this.data.amendmentContractComment;
        this.selectedReasons = this.data.selectedReasons;
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.reason-item {
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  width: 100%;
  font-size: 90%;
  background: #fff;
  padding: 10px 17px 15px 20px;

  &__sub-type {
    // margin-top: 10px;
    background: #fff;
    padding: 20px;
    border-radius: 4px;
    border: 1px solid #e2e2e2;
    border-top: none;
    margin-top: -6px;
    position: relative;
    overflow: visible;

    &::before {
      content: '';
      position: absolute;
      top: -3px;
      left: -1px;
      right: -1px;
      height: 13px;
      background: linear-gradient(
        to bottom,
        rgba(226, 226, 226, 1) 0%,
        rgba(255, 255, 255, 0) 100%
      );
      pointer-events: none;
      z-index: 1;
    }
  }
}

.custom-drop-down__extended ::v-deep {
  .vs__dropdown-menu {
    z-index: 1 !important;
  }
}

.custom-input__extended ::v-deep {
  .input-display {
    display: flex;
    padding: 5px;
    padding-left: 10px;
    background-color: #f8f8f8;
    border: 1px solid rgba(60, 60, 60, 0.26);
    border-radius: 4px;
    white-space: normal;
    margin-left: 0px;
  }
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: max-height 0.3s ease, opacity 0.3s ease;
  max-height: 1000px;
  opacity: 1;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  max-height: 0;
  opacity: 0;
}

.file-amendment-reason-input__extended {
  margin: unset !important;
}

.btn-action-size > i {
  margin-right: 0 !important;
}

.file-amendment-reason-input__extended .file-input-container {
  width: 38px !important;
  height: 38px !important;
  border-color: map-get($colors, 'green');
  margin-right: unset !important;
}

.file-amendment-reason-input__extended
  .file-input-container
  em.fas.fa-file-plus.pr-4.text-green:before {
  content: '\f0e2';
}

.file-amendment-reason-input__extended .file-input-container span {
  display: none;
}
.file-amendment-reason-input__extended div.button-container {
  display: none !important;
}

.document-button-icon {
  height: 33px;
  width: 33px;
  padding: 0;
}
</style>
